import React, { HTMLAttributes, ReactElement } from 'react'
import { LayoutBottomPaneType } from './types-and-constants/LayoutPaneTypesAndConstants'
import { getRetainBehaviorModifierForPane } from '../helpers/get-retain-behavior-for-pane'
import { Retain } from '../../../atoms/Retain/Retain'
import { RetainBehaviorModifier } from '../../../atoms/Retain/constants/modifiers'

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'className'> {
    paneType: LayoutBottomPaneType
    children?: ReactElement | ReactElement[]
    customRetainBehaviorModifier?: RetainBehaviorModifier
}

export const LayoutBottomPaneRSC = ({
    paneType,
    children,
    customRetainBehaviorModifier,
    ...props
}: Props): ReactElement => {
    if (!paneType) {
        console.error('LayoutBottomPane must be defined for the Layout to read it.')
    }

    const bottomPaneClasses = [
        'o-layout__bottom-pane',
        paneType === LayoutBottomPaneType.BOTTOM_PANE_FIXED && 'o-layout__bottom-pane--fixed',
        paneType === LayoutBottomPaneType.BOTTOM_PANE_STICKY && 'o-layout__bottom-pane--sticky',
    ]
        .filter((i) => !!i)
        .join(' ')

    return (
        <div {...props} className={bottomPaneClasses}>
            <Retain
                behaviorModifiers={[customRetainBehaviorModifier ?? getRetainBehaviorModifierForPane(paneType)]}
                className="h-full"
                behaviorOnly
            >
                {children ?? <></>}
            </Retain>
        </div>
    )
}
